import { createSlice } from '@reduxjs/toolkit';

export const usersSlice = createSlice({
  name: 'users',
  initialState: {
    users: [],
    currentUser: {
      id: 0,
      name: '',
      username: '',
      password: '',
      role_id: 0,
      role: '',
      role_name: '',
      clientLogo : null,
    },
    customers: [],
  },
  reducers: {
    setUsers: (state, action) => {
      state.users = action.payload;
    },
    addUser: (state, action) => {
      state.users.push(action.payload);
    },
    deleteUser: (state, action) => {
      state.users = state.users.filter((user) => user.id !== action.payload);
    },
    updateUser: (state, action) => {
      state.users = state.users.map((user) => (user.id === action.payload.id ? action.payload : user));
    },
    viewUser: (state, action) => {
      state.currentUser = action.payload;
    },
    resetCurrentUser: (state) => {
      state.currentUser = {
        id: 0,
        name: '',
        username: '',
        password: '',
        role_id: 0,
        role: '',
        role_name: '',
        clientLogo : null,
      };
    },
    setId: (state, action) => {
      state.currentUser.id = action.payload;
    },
    setPassword: (state, action) => {
      state.currentUser.password = action.payload;
    },
    setCustomers: (state, action) => {
      state.customers = action.payload;
    },
  },
});

export const {
  setUsers,
  addUser,
  deleteUser,
  updateUser,
  viewUser,
  resetCurrentUser,
  setPassword,
  setId,
  setCustomers,
} = usersSlice.actions;

export const selectUsers = (state) => state.users.users;
export const selectCurrentUser = (state) => state.users.currentUser;
export const selectCustomers = (state) => state.users.customers;

export default usersSlice.reducer;
